import { createSlice } from "@reduxjs/toolkit";
import { claimCommunity } from "./claimCommunityApi";

const claimCommunitySlice = createSlice({
  name: "claimCommunity",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(claimCommunity.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(claimCommunity.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(claimCommunity.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default claimCommunitySlice.reducer;
